import React from 'react';
import { Link } from 'react-router-dom';
import RegisterForm from '../auth/RegisterForm';

const RegisterPage = () => (
  <div className="auth-page">
    <div className="auth-container glass-card">
      <RegisterForm />
      <p className="auth-link">
        Already have an account? <Link to="/login">Login</Link>
      </p>
    </div>
    <style>{`
      .auth-page {
        min-height: 100vh;
        display: flex; align-items: center; justify-content: center;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        padding: 1rem;
      }
      .auth-container {
        width: 100%; max-width: 450px;
      }
      .auth-link {
        text-align: center; margin-top: 1.5rem;
      }
      .auth-link a {
        color: var(--primary); font-weight: 600;
      }
    `}</style>
  </div>
);
export default RegisterPage;